import { render, staticRenderFns } from "./flightOrder.vue?vue&type=template&id=0857ec3c&"
import script from "./flightOrder.vue?vue&type=script&lang=ts&"
export * from "./flightOrder.vue?vue&type=script&lang=ts&"
import style0 from "./flightOrder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports